export default __webpack_public_path__ + "static/media/5-color.d499bfc6.svg";